module.exports = __webpack_public_path__ + "static/media/materials.3615419d.md";